import { Link } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import { testimonials, stats } from '@/mocks/testimonials';

const principles = [
  {
    icon: 'ri-heart-3-line',
    title: '只选甜向',
    desc: '收进来的每一条瓜都要先过一遍“会不会让人心里发闷”这道题，答案是不的话，就不推荐。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '尊重隐私',
    desc: '只整理公开渠道里已经出现过的信息，不扒私人行程、不放大私人情绪，也不做无依据的推测。',
  },
  {
    icon: 'ri-edit-2-line',
    title: '先读再推',
    desc: '编辑组坚持自己先完整读过一遍才上推荐位，宁可少发一条，也不凑数。',
  },
  {
    icon: 'ri-refresh-line',
    title: '有错就改',
    desc: '若当事人或读者指出内容有误、希望撤下，我们会在核实后第一时间处理并说明。',
  },
];

const timeline = [
  { year: '起点', title: '一个只想聊甜事的群聊', desc: '最初只是几个朋友在群里互相分享让人开心的恋爱小事。' },
  { year: '成长', title: '从群聊变成一片瓜田', desc: '内容越攒越多，于是把它们整理成可以随时翻看的分类与小站。' },
  { year: '现在', title: '每天 3 条，稳定上新', desc: '甜瓜日报上线，只挑当天最甜的三条送到订阅者的邮箱。' },
];

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'AboutPage',
      name: '关于糖心吃瓜',
      url: 'https://lhyf56.cn/about',
      description: '糖心吃瓜的品牌介绍、网站定位、内容原则与联系方式。',
      inLanguage: 'zh-CN',
    },
    {
      '@type': 'Organization',
      name: '糖心吃瓜',
      url: 'https://lhyf56.cn/',
      email: 'hello@tangxinchigua.com',
      description: '只磕甜向小瓜的娱乐内容站',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer support',
        email: 'hello@tangxinchigua.com',
        availableLanguage: ['zh-CN'],
      },
    },
  ],
};

export default function About() {
  return (
    <>
      <title>关于我们 - 糖心吃瓜的内容原则与编辑部 | 糖心吃瓜</title>
      <meta
        name="description"
        content="了解糖心吃瓜的定位、发展理念与内容原则。我们只整理公开渠道的甜向内容，坚持先读再推、尊重隐私、有错就改。"
      />
      <meta name="keywords" content="糖心吃瓜,关于我们,内容原则,甜味瓜,恋爱小料" />
      <link rel="canonical" href="https://lhyf56.cn/about" />
      <meta name="robots" content="index, follow" />
      <meta property="og:title" content="关于糖心吃瓜 - 内容原则与编辑部" />
      <meta property="og:description" content="只整理公开渠道的甜向内容，坚持先读再推、尊重隐私、有错就改。" />
      <meta property="og:url" content="https://lhyf56.cn/about" />
      <meta name="twitter:card" content="summary_large_image" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />

      <SiteHeader />
      <main className="w-full">
        <section className="w-full bg-background-100 border-b border-background-200">
          <div className="w-full px-4 md:px-8 py-10 md:py-16">
            <nav aria-label="面包屑" className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
              <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
              <span className="text-foreground-800">关于我们</span>
            </nav>
            <div className="mt-6 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
              <div className="lg:col-span-7">
                <p className="flex items-center gap-2 text-xs tracking-widest text-primary-600">
                  <i className="ri-heart-3-line" aria-hidden="true"></i>
                  ABOUT TANGXIN
                </p>
                <h1 className="mt-3 font-heading text-3xl md:text-5xl leading-snug text-foreground-950">
                  一片专门用来
                  <br />
                  存放<span className="text-primary-500">好心情</span>的瓜田
                </h1>
                <p className="mt-5 max-w-2xl text-sm md:text-base text-foreground-700 leading-relaxed">
                  糖心吃瓜成立于一次很普通的深夜聊天。我们发现，很多人其实只想看点让人开心的东西，
                  却总被更刺激的内容挤到页面下方。于是我们决定只做甜的那一半。
                </p>
              </div>
              <div className="lg:col-span-5">
                <div className="w-full h-56 md:h-72 overflow-hidden rounded-2xl bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Warm%20cozy%20editorial%20desk%20scene%20with%20notebook%2C%20dried%20flowers%2C%20cup%20of%20milk%20tea%20and%20a%20small%20heart%20shaped%20ceramic%2C%20soft%20cream%20and%20coral%20palette%2C%20gentle%20sunlight%20through%20window%2C%20lifestyle%20photography&width=1000&height=800&seq=txabout-01&orientation=landscape"
                    alt="糖心吃瓜编辑部温暖的工作桌面"
                    title="糖心吃瓜编辑部 - 只做甜的那一半"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-8 py-14 md:py-20">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-xl border border-background-200 bg-background-50 p-5">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                  <i className={`${s.icon} text-base`} aria-hidden="true"></i>
                </span>
                <p className="mt-4 font-heading text-xl text-foreground-950">{s.value}</p>
                <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="w-full bg-background-100 border-y border-background-200">
          <div className="w-full px-4 md:px-8 py-14 md:py-20">
            <div className="max-w-2xl">
              <p className="text-xs tracking-widest text-primary-600">OUR PRINCIPLES</p>
              <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">我们的四条内容原则</h2>
              <p className="mt-3 text-sm text-foreground-600">
                这些原则决定了什么内容能出现在糖心吃瓜，也决定了我们主动放弃什么。
              </p>
            </div>
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5">
              {principles.map((p) => (
                <article key={p.title} className="rounded-xl border border-background-200 bg-background-50 p-6">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-800">
                    <i className={`${p.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-4 text-base font-medium text-foreground-950">{p.title}</h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{p.desc}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-8 py-14 md:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-4">
              <p className="text-xs tracking-widest text-primary-600">OUR STORY</p>
              <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950 leading-snug">
                从群聊里
                <br />
                长出来的一片瓜田
              </h2>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                我们没有宏大的规划，只是想把让人觉得温柔的事情，认真存好、整理清楚，再端到愿意看的人面前。
              </p>
            </div>
            <ol className="lg:col-span-8 flex flex-col gap-6">
              {timeline.map((t) => (
                <li key={t.year} className="relative flex gap-5 rounded-xl border border-background-200 bg-background-50 p-6">
                  <span className="absolute left-0 top-6 h-10 w-1 rounded-r bg-primary-400" aria-hidden="true"></span>
                  <span className="shrink-0 font-heading text-primary-500 text-lg w-12 pl-3">{t.year}</span>
                  <div>
                    <h3 className="text-base font-medium text-foreground-950">{t.title}</h3>
                    <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{t.desc}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </section>

        <section className="w-full bg-background-100 border-y border-background-200">
          <div className="w-full px-4 md:px-8 py-14 md:py-20">
            <div className="max-w-2xl">
              <p className="text-xs tracking-widest text-primary-600">READERS SAY</p>
              <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">瓜民怎么说</h2>
            </div>
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-5">
              {testimonials.map((t) => (
                <figure key={t.name} className="flex h-full flex-col rounded-xl border border-background-200 bg-background-50 p-6">
                  <i className="ri-double-quotes-l text-2xl text-secondary-300" aria-hidden="true"></i>
                  <blockquote className="mt-3 flex-1 text-sm text-foreground-700 leading-relaxed">{t.text}</blockquote>
                  <figcaption className="mt-5 flex items-center gap-3 border-t border-background-100 pt-4">
                    <div className="w-10 h-10 shrink-0 overflow-hidden rounded-full bg-background-200">
                      <img src={t.avatar} alt={`${t.name}的头像`} className="w-full h-full object-cover object-top" />
                    </div>
                    <div>
                      <p className="text-sm text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-8 py-14 md:py-20">
          <div className="rounded-2xl border border-background-200 bg-secondary-950 p-6 md:p-12">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
              <div className="lg:col-span-7">
                <p className="text-xs tracking-widest text-primary-300">CONTACT US</p>
                <h2 className="mt-3 font-heading text-2xl md:text-4xl text-secondary-50 leading-snug">
                  有想说的甜瓜
                  <br />
                  直接写信给我们
                </h2>
                <p className="mt-4 max-w-xl text-sm text-secondary-300 leading-relaxed">
                  无论是投稿、纠错，还是希望撤下某条内容，都可以发到这个邮箱。我们工作日都会看，
                  涉及隐私与纠错的来信会优先处理。
                </p>
              </div>
              <div className="lg:col-span-5 flex flex-col gap-3">
                <a
                  href="mailto:hello@tangxinchigua.com"
                  className="flex items-center gap-3 rounded-xl bg-secondary-900 px-5 py-4 hover:bg-primary-500 transition-colors cursor-pointer"
                >
                  <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-950/40 text-secondary-100">
                    <i className="ri-mail-line" aria-hidden="true"></i>
                  </span>
                  <span>
                    <span className="block text-xs text-secondary-300">编辑部邮箱</span>
                    <span className="block text-sm text-secondary-50">hello@tangxinchigua.com</span>
                  </span>
                </a>
                <div className="flex items-center gap-3 rounded-xl bg-secondary-900 px-5 py-4">
                  <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-950/40 text-secondary-100">
                    <i className="ri-time-line" aria-hidden="true"></i>
                  </span>
                  <span>
                    <span className="block text-xs text-secondary-300">工作时间</span>
                    <span className="block text-sm text-secondary-50">工作日 10:00 - 19:00</span>
                  </span>
                </div>
                <Link
                  to="/fresh"
                  className="rounded-full bg-primary-500 px-5 py-3 text-center text-sm text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  先去逛逛瓜田速递
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}